import { PageHeader } from "../components/common";
import { BerthRequests } from "../components/BerthRequests";

export default function RichiesteOrmeggio() {
  return (
    <div data-testid="berth-requests-page">
      <PageHeader title="Richieste di ormeggio" subtitle="Richieste arrivate dal modulo del sito pubblico." />
      <BerthRequests />
    </div>
  );
}
